<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create FAQ'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <input-text
            name="heading"
            label="* Heading"
            v-model="form.heading"
            :error="errors.heading ? errors.heading[0] : null"
            :maxlength=200
        />

        <input-text
            name="jump_id"
            label="Heading Jump ID (excluding #)"
            v-model="form.jump_id"
            class="mt-3"
            :error="errors.jump_id ? errors.jump_id[0] : null"
            :maxlength=255
        />

        <input-text
            name="jump_text"
            label="Quick Navi Menu anchor text for Heading"
            v-model="form.jump_text"
            class="mt-3"
            :error="errors.jump_text ? errors.jump_text[0] : null"
            :maxlength=255
        />

        <input-rich-text
            name="overview"
            label="Overview"
            v-model="form.overview"
            class="mt-3"
            :language="form.language"
            :error="errors.overview ? errors.overview[0] : null"
        />

        <div class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3">
            <p class="text-gray-700 mb-4">* Language</p>
            <reference
                create-text="Create new language and link language to this page"
                link-text="Link an existing language"
                :creatable="false"
                :editable="false"
                :error="errors.language_id ? errors.language_id[0] : null"
                v-model="form.language"
                model-data="Site Language"
            />
        </div>

        <p class="mt-3">FAQs</p>
        <faq-input
            v-model="form.question_and_answers"
            :language="form.language"
            :error-bag="errors"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import FaqInput from "./form/FaqInput";
import crudForm from "../mixins/crudForm";

export default {
    name: "FaqForm",
    components: { FaqInput },
    mixins: [crudForm],
    data() {
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                language_id: this.getFormData("language_id"),
                heading: this.getFormData("heading"),
                jump_id: this.getFormData("jump_id"),
                jump_text: this.getFormData("jump_text"),
                question_and_answers: this.getFormData("question_and_answers"),
                overview: this.getFormData("overview"),
            },
        };
    },
};
</script>
